import { MAPS } from "@69ly/maps";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { GettingStarted } from "../components/GettingStarted.tsx";
import { useCurrentTeam } from "../lib/current-team.tsx";
import { mapIconUrl, mapShotUrl } from "../lib/map-art.ts";
import { useMapCounts } from "../lib/stuff-queries.ts";

/** Library home: one card per map, with what is left to learn. */
export function MapPickerPage() {
  const { t } = useTranslation();
  const { scope, team } = useCurrentTeam();
  const counts = useMapCounts(scope).data ?? [];
  const total = counts.reduce((n, c) => n + c.total, 0);

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1 className="page-title">{t("picker.title")}</h1>
          <p className="muted">{team ? t("picker.intro") : t("picker.introPersonal")}</p>
        </div>
      </div>
      <div className="columns">
        <ul className="map-grid-cards column-main" aria-label={t("picker.title")}>
          {MAPS.filter((m) => m.activeDuty).map((m) => {
            const c = counts.find((x) => x.map === m.id);
            return (
              <li key={m.id}>
                <Link to={`/library/${m.id}`} className="map-card">
                  <span className="map-card-art">
                    <img className="map-card-shot" src={mapShotUrl(m.id)} alt="" loading="lazy" />
                    <img className="map-card-icon" src={mapIconUrl(m.id)} alt="" loading="lazy" />
                  </span>
                  <span className="map-card-name">{m.name}</span>
                  <span className="map-card-count">
                    {c ? t("picker.count", { count: c.total }) : t("picker.none")}
                    {c && c.total > 0 && <span className="muted"> · {t("picker.learned", { learned: c.learnedByMe, total: c.total })}</span>}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
        {total === 0 && (
          <div className="column-side">
            <GettingStarted hasStuff={false} newStuffTo="/library/de_mirage/new" />
          </div>
        )}
      </div>
    </div>
  );
}
